// TokenDownloadPage.js
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { pdf } from "@react-pdf/renderer";
import { TokenPdf } from "../helpers/MailHelper";
import { GetCanteenManagementRecordHelper } from "../helpers/TokenConfigHelper";
import { toast } from "react-toastify";

export default function TokenDownloadPage() {
  const { token_id, region } = useParams();
  const decodedToken = JSON.parse(atob(token_id));
  const [tokenData, setTokenData] = useState(null);
    const fetchData = () => {
      GetCanteenManagementRecordHelper({
        domain_name: decodedToken?.domain_name,
        from_date: decodedToken?.today,
        to_date: decodedToken?.today,
        user_id: decodedToken?.user_id,
        canteen_management_regions_pk:
          decodedToken?.canteen_management_regions_pk,
        employee_canteen_tokens_usage_pk: decodedToken?.token_id
      }).then((res) => {
        if (res?.data?.statuscode === 200) {
          if(res?.data?.data?.length) {
            setTokenData(res?.data?.data?.[0]);
          } else {
            setTokenData(null);
            setTimeout(() => {
              window.location.replace("https://meepl.day");
            }, 1200);
            toast.error("Token expired");
          }
        } else {
          setTimeout(() => {
            window.location.replace("https://meepl.day");
          }, 1200);
          toast.error("Token expired");
        }
      });
    }
  useEffect(() => {
    fetchData();
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token_id]);

  useEffect(() => {
    if (!tokenData) return;

    const downloadAndRedirect = async () => {
      const blob = await pdf(
        <TokenPdf
          tokenCode={tokenData?.uuid}
          employeeName={tokenData?.employee_name}
          companyName={decodedToken?.company}
          tokens={tokenData?.usage_tokens}
          region={region}
        />
      ).toBlob();

      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${region}-${tokenData?.uuid || "token"}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      setTimeout(() => {
        window.location.replace("https://meepl.day");
      }, 1200);
    };

    downloadAndRedirect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tokenData]);

  return (
    <div
      style={{
        fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
        padding: 24,
        textAlign: "center",
      }}
    >
      Preparing your token PDF…
    </div>
  );
}
